import { motion } from "motion/react";
import { cn } from "@/lib/utils";

interface GlobalLoaderProps {
  message?: string;
  className?: string;
  fullPage?: boolean;
}

export function GlobalLoader({
  message,
  className,
  fullPage,
}: GlobalLoaderProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-6",
        fullPage ? "min-h-dvh" : "min-h-[50vh]",
        className
      )}
    >
      <div className="relative">
        <div className="absolute -inset-4 rounded-3xl bg-gradient-to-br from-rose-500/15 to-red-500/10 blur-2xl" />
        <motion.div
          animate={{ scale: [1, 1.06, 1] }}
          transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut" }}
          className="relative"
        >
          <img
            src="/BLDR.png"
            alt="BLDR"
            className="h-16 w-16 rounded-2xl shadow-lg shadow-rose-500/10"
          />
        </motion.div>
      </div>
      <div className="flex flex-col items-center gap-3">
        <div className="h-1 w-28 overflow-hidden rounded-full bg-rose-500/10">
          <motion.div
            className="h-full w-8 rounded-full bg-gradient-to-r from-rose-500 to-red-500"
            animate={{ x: ["-32px", "112px"] }}
            transition={{
              duration: 1.2,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          />
        </div>
        {message && (
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
            className="text-muted-foreground text-sm"
          >
            {message}
          </motion.p>
        )}
      </div>
    </div>
  );
}
